<template>
    <!-- 右边主体[[ -->
    <div class="g-content g-autofixheight order-detail-supplier" v-loading="loading">
        <!-- 派单[[ -->
        <div
            class="g-popup g-popup-transparent js-popup-confirm-distribute"
            v-if="assignOrderDialog.show"
        >
            <div class="popup-con confirm-popup confirm-distribute">
                <div class="popup-close js-close-view">
                    <i class="ico ico-close" @click="assignOrderDialog.show=false"></i>
                </div>
                <h5 class="popup-title">派单确认</h5>
                <p class="confirm-content">派单后，此订单将无法新增及编辑作者订单。是否继续派单？</p>
                <ul class="distribute-list g-scrollbar">
                    <li
                        class="distribute-item"
                        v-for="(author,index) in assignOrderDialog.authorList"
                        :key="index"
                    >
                        <span class="item-title">订单派给</span>
                        <div class="distribute-detail">
                            {{ author.userName }}
                            <span class="order-no">{{ author.object_name }}</span>
                        </div>
                    </li>
                </ul>
                <div class="btn-group f-clearfix">
                    <a class="g-btn confirm-btn" href="javascript:;" @click="doAssignOrder">派单</a>
                    <a
                        class="g-btn cancell f-fr"
                        href="javascript:;"
                        @click="assignOrderDialog.show=false"
                    >取消</a>
                </div>
            </div>
        </div>
        <!-- 派单]] -->

        <!-- 提请接单[[ -->
        <div
            class="g-popup g-popup-transparent js-popup-confirm-commit"
            v-if="submitOrderDialog.show"
        >
            <div class="popup-con apply-order-popup">
                <div class="popup-close js-close-view">
                    <i class="ico ico-close" @click="submitOrderDialog.show = false"></i>
                </div>
                <h5 class="popup-title">提请结单</h5>
                <p class="confirm-content">提交后订单变为“待结单状态”，由内容经理审核，审核通过后将按照提请结单的金额结算</p>
                <div class="order-details">
                    <div
                        class="order-title f-hide-col-1"
                    >{{ submitOrderDialog.supplierOrderInfo.order_name }}</div>
                    <div class="order-type-num f-clearfix">
                        <div class="order-types f-fl">
                            <div class="order-type">
                                图文:
                                <div class="num-details">
                                    <span
                                        class="num"
                                    >{{ submitOrderDialog.supplierOrderInfo.text_pass }}/</span>
                                    {{ submitOrderDialog.supplierOrderInfo.text }}
                                </div>
                            </div>
                            <div class="order-type">
                                小说:
                                <div class="num-details">
                                    <span
                                        class="num"
                                    >{{ submitOrderDialog.supplierOrderInfo.novel_pass }}/</span>
                                    {{ submitOrderDialog.supplierOrderInfo.novel }}
                                </div>
                            </div>
                            <div class="order-type">
                                含税总预算:
                                <div
                                    class="num-details"
                                >{{ $common.toThousandsFilter(parseFloat(submitOrderDialog.supplierOrderInfo.budget_amount)+parseFloat(submitOrderDialog.supplierOrderInfo.budget_tax)) }}</div>
                            </div>
                        </div>
                        <div class="order-types f-fr">
                            <div class="order-type">
                                视频:
                                <div class="num-details">
                                    <span
                                        class="num"
                                    >{{ submitOrderDialog.supplierOrderInfo.video_pass }}/</span>
                                    {{ submitOrderDialog.supplierOrderInfo.video }}
                                </div>
                            </div>
                            <div class="order-type">
                                漫画:
                                <div class="num-details">
                                    <span
                                        class="num"
                                    >{{ submitOrderDialog.supplierOrderInfo.painting_pass }}/</span>
                                    {{ submitOrderDialog.supplierOrderInfo.painting }}
                                </div>
                            </div>
                            <div class="order-type">
                                含税实际额:
                                <div
                                    class="num-details num-detail-orange"
                                >{{ getRealAmountAddTax(submitOrderDialog.supplierOrderInfo)}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="btn-group f-clearfix">
                    <a
                        class="g-btn confirm-btn"
                        href="javascript:;"
                        @click="doSubmitStatement(submitOrderDialog.supplierOrderInfo.id)"
                    >确认</a>
                    <a
                        class="g-btn cancell f-fr"
                        href="javascript:;"
                        @click="submitOrderDialog.show = false"
                    >取消</a>
                </div>
            </div>
        </div>
        <!-- 提请接单]] -->

        <!-- 提请接单成功弹窗[[ -->
        <div class="g-popup g-popup-transparent js-popup-commit-success f-hide">
            <div class="popup-con commit-success">
                <div class="popup-close js-close-view">
                    <i class="ico ico-close"></i>
                </div>
                <h5 class="popup-title">提交成功</h5>
                <div class="confirm-content">
                    <div class="confirm-ico"></div>
                    <span class="confirm-tip">提交成功,</span>
                    <span class="confirm-tip-text">请等审核收结果</span>
                </div>
            </div>
        </div>
        <!-- 提请接单成功弹窗]] -->

        <div class="order-message f-clearfix">
            <img class="order-detail-header f-fl" :src="demandInfo.logoUrl" width="80" height="80">
            <div class="order-detail-intro f-fr">
                <div class="order-name-contain f-clearfix">
                    <span class="order-name f-hide-col-1">{{ demandInfo.demand_name }}</span>
                    <span class="status f-fr">{{demandInfo.demandStatusText }}</span>
                </div>
                <div class="order-lines order-num-line">
                    <div class="order-num">
                        单号:
                        <span class="order-num-detail">{{ demandInfo.id }}</span>
                    </div>
                    <div class="budget-all">
                        含税总预算:
                        <div class="budget-all-num" style="width: 100px">
                            <span class="money-ico">￥</span>
                            {{ $common.toThousandsFilter(demandInfo.totalBudgetTax)}}
                        </div>
                    </div>
                    <div class="budget-all">
                        税后实收:
                        <div class="budget-all-num">
                            <span class="money-ico">￥</span>
                            {{ $common.toThousandsFilter(demandInfo.totalBudget)}}
                        </div>
                        <div class="ask-ico">
                            <div class="answer-show">
                                <i class="triangle"></i>
                                <div
                                    class="answer-text"
                                >税费￥ {{ $common.toThousandsFilter(demandInfo.budgetTax)}} 已由腾讯公司代缴</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="order-lines order-type-line">
                    <div class="order-num">
                        类型:
                        <span
                            class="order-num-detail"
                        >{{ demandInfo.demandTypeText }} ({{ demandInfo.content_type }})</span>
                    </div>
                    <div class="budget-all">
                        含税实际额:
                        <div class="budget-all-num" style="width: 100px">
                            <span class="money-ico">￥</span>
                            {{ $common.toThousandsFilter(demandInfo.realAmountTax)}}
                        </div>税后实收:
                        <div class="budget-all-num">
                            <span class="money-ico">￥</span>
                            {{ $common.toThousandsFilter(demandInfo.realAmount)}}
                        </div>
                        <div class="ask-ico">
                            <div class="answer-show">
                                <i class="triangle"></i>
                                <div
                                    class="answer-text"
                                >税费￥{{ $common.toThousandsFilter(demandInfo.tax)}}已由腾讯公司代缴</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="order-lines order-time-line">
                    <div class="order-num">
                        时间:
                        <span
                            class="order-num-detail"
                        >{{ demandInfo.start_time }}~{{demandInfo.end_time}}</span>
                    </div>
                </div>
                <div class="order-lines order-type-num-line">
                    图文：
                    <span class="order-num-detail">{{ demandInfo.articlesNum }}</span>
                    小说：
                    <span class="order-num-detail">{{ demandInfo.novelNum }}</span>
                    视频：
                    <span class="order-num-detail">{{ demandInfo.videoNum }}</span>
                    漫画：
                    <span class="order-num-detail">{{ demandInfo.cartoonNum }}</span>
                </div>
                <div class="order-lines order-tips-line">
                    <div class="order-num">
                        说明:
                        <span class="order-num-detail f-hide-col-1">{{ demandInfo.produce_desc }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="commit-task g-autofixheight">
            <!-- 选项卡[[ -->
            <div class="g-tab tab1">
                <a
                    href="javascript:;"
                    v-for="(item,index) in tabList"
                    :key="index"
                    @click="changeTab(index)"
                >
                    <div class="g-tab-item" :class="{'g-tab-item-active': index == curTab}">{{item}}</div>
                </a>
            </div>
            <!-- 选项卡]] -->
            <!-- 拆单列表[[ -->
            <div class="order-detail-status order-detail-status-1" v-if="curTab==0">
                <div class="searchs-list">
                    <div class="search f-clearfix">
                        <select-box
                            :selectList="pageConf.supplierOrderStatusList"
                            itemTitle="订单状态"
                            :selected.sync="params.orderStatus"
                        ></select-box>
                        <div class="list f-fl list-title">
                            <p class="name f-fl">
                                <label for="keyword">订单名称</label>
                            </p>
                            <div class="g-select f-fl">
                                <input
                                    class="input"
                                    name="keyword"
                                    type="text"
                                    placeholder="请输入订单名称"
                                    v-model.trim="params.orderName"
                                >
                            </div>
                        </div>
                        <div class="inquire f-fr">
                            <input
                                class="btn"
                                type="button"
                                value="查询"
                                @click="getSupplierOrderList"
                            >
                        </div>
                    </div>
                    <ul class="freelance-list">
                        <li
                            class="list f-clearfix"
                            v-for="(supplierOrder,index) in supplierOrderList"
                            :key="index"
                        >
                            <div class="file-con f-fl">
                                <div class="file-intro-con f-clearfix">
                                    <div class="file-intro">
                                        <a
                                            class="file-name link f-hide-col-1"
                                            @click="viewSupplierOrderDetail(supplierOrder)"
                                        >{{ supplierOrder.order_name}}</a>
                                        <div class="type-detal-con">
                                            <div class="type-item">
                                                视频：
                                                <span
                                                    class="type-num"
                                                >{{ supplierOrder.video_pass || 0}}</span>
                                                <span
                                                    class="type-all"
                                                >/{{ supplierOrder.video || 0}}</span>
                                            </div>
                                            <div class="type-item">
                                                图文：
                                                <span
                                                    class="type-num"
                                                >{{ supplierOrder.text_pass || 0}}</span>
                                                <span class="type-all">/{{ supplierOrder.text || 0}}</span>
                                            </div>
                                        </div>
                                        <div class="type-detal-con">
                                            <div class="type-item">
                                                漫画：
                                                <span
                                                    class="type-num"
                                                >{{ supplierOrder.painting_pass || 0}}</span>
                                                <span
                                                    class="type-all"
                                                >/{{ supplierOrder.painting || 0 }}</span>
                                            </div>
                                            <div class="type-item">
                                                小说：
                                                <span
                                                    class="type-num"
                                                >{{ supplierOrder.novel_pass || 0}}</span>
                                                <span
                                                    class="type-all"
                                                >/{{ supplierOrder.novel || 0}}</span>
                                            </div>
                                        </div>

                                        <div
                                            class="date"
                                        >{{ supplierOrder.start_time.substr(0,10) }} ~ {{ supplierOrder.end_time.substr(0,10) }}</div>
                                    </div>
                                    <div class="budget f-fr">
                                        <div class="type-item f-hide-col-1">
                                            含税总预算：
                                            <span
                                                class="type-all"
                                            >{{ getBudgetAddTax(supplierOrder)}}</span>
                                        </div>
                                        <div class="type-item f-hide-col-1">
                                            含税实际额：
                                            <span
                                                class="type-all"
                                            >{{ getRealAmountAddTax(supplierOrder)}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- 制单中[[ -->
                            <div
                                class="operation making-order f-fr"
                                v-if="supplierOrder.order_status== 5000"
                            >
                                <p class="status">
                                    <span class="color-theme">制单中</span>
                                </p>
                                <p class="btn">
                                    <a
                                        class="g-btn"
                                        href="javascript:;"
                                        @click="handleClick(supplierOrder,'editOrder')"
                                    >编辑</a>
                                    <a
                                        class="g-btn"
                                        href="javascript:;"
                                        @click="showAssignDialog(supplierOrder)"
                                    >派单</a>
                                    <a
                                        class="g-btn"
                                        href="javascript:;"
                                        @click="handleClick(supplierOrder,'deleteOrder')"
                                    >删除</a>
                                </p>
                            </div>
                            <!-- 制单中]] -->
                            <!-- 待接单[[ -->
                            <div
                                class="operation reject-one js-wait-order f-fr"
                                v-else-if="supplierOrder.order_status== 5001"
                            >
                                <p class="status">
                                    <span class="color-theme">待接单</span>
                                </p>
                                <p class="btn">
                                    <a
                                        class="g-btn"
                                        href="javascript:;"
                                        @click="handleClick(supplierOrder,'doSubmit')"
                                    >提审</a>
                                </p>
                            </div>
                            <!-- 待接单]] -->
                            <!-- 执行中[[ -->
                            <div
                                class="operation reject-one js-wait-commit f-fr"
                                v-else-if="supplierOrder.order_status== 5004"
                            >
                                <p class="status">
                                    <span class="color-theme">执行中</span>
                                </p>
                                <p class="btn">
                                    <a
                                        class="g-btn"
                                        href="javascript:;"
                                        @click="submitStatement(supplierOrder)"
                                    >提请结单</a>
                                </p>
                            </div>
                            <!-- 执行中]] -->
                            <!-- 待结算[[ -->
                            <div
                                class="operation wait-balance f-fr"
                                v-else-if="supplierOrder.order_status== 5006"
                            >
                                <p class="status">
                                    <span class="color-theme">待结算</span>
                                </p>
                            </div>
                            <!-- 待结算]] -->
                            <!-- 结算中[[ -->
                            <div
                                class="operation wait-balance f-fr"
                                v-else-if="supplierOrder.order_status== 5007"
                            >
                                <p class="status">
                                    <span class="color-theme">结算中</span>
                                </p>
                            </div>
                            <!-- 结算中]] -->
                            <!-- 已中止[[ -->
                            <div
                                class="operation wait-balance f-fr"
                                v-else-if="supplierOrder.order_status== 5020"
                            >
                                <p class="status">
                                    <span class="color-theme">已中止</span>
                                </p>
                            </div>
                            <!-- 已中止]] -->
                            <!-- 终止结算[[ -->
                            <div
                                class="operation wait-balance f-fr"
                                v-else-if="supplierOrder.order_status== 5021"
                            >
                                <p class="status">
                                    <span class="color-theme">终止结算</span>
                                </p>
                            </div>
                            <!-- 终止结算]] -->
                            <!-- 其余状态[[ -->
                            <div class="operation already-order f-fr" v-else>
                                <p class="status">
                                    <span class="color-theme">{{ supplierOrder.orderStatusText }}</span>
                                </p>
                            </div>
                            <!-- 其余状态]] -->
                        </li>
                    </ul>

                    <!-- 空数据 start -->
                    <div class="empty" v-if="supplierOrderList.length===0">
                        <img class="empty-img" src="~Assets/img/pages/v4/radar-no-result.png">
                    </div>
                    <!-- 空数据 end -->
                </div>
                <div class="footer-bar">
                    <div class="footer-bar-btn">
                        <div class="g-bottom-btn btn-group">
                            <a class="button f-fr" href="javascript:;" @click="goBack">返回</a>
                            <!--选中状态  为a标签添加类 active -->
                            <a
                                class="button active f-fr"
                                href="javascript:;"
                                @click="unpackOrder"
                            >拆单</a>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 内容审核]] -->
            <div class="order-detail-status order-detail-status-2" v-if="curTab==1">
                <div class="searchs-list">
                    <!-- ----------------------------------------------------------------------------- -->
                    <div class="search f-clearfix">
                        <select-box
                            :selectList="pageConf.articleTypeList"
                            :itemTitle="'内容类型'"
                            :selected.sync="params.type"
                        ></select-box>
                        <select-box
                            :selectList="pageConf.articleStatusList"
                            :itemTitle="'内容状态'"
                            :selected.sync="params.status"
                        ></select-box>
                        <div class="list f-fl list-title">
                            <p class="name f-fl">
                                <label for="keyword">内容标题</label>
                            </p>
                            <div class="g-select f-fl">
                                <input
                                    class="input"
                                    name="keyword"
                                    type="text"
                                    placeholder="请输入要搜索的标题"
                                    v-model="params.title"
                                >
                                <!--0629修改-->
                            </div>
                        </div>
                        <div class="inquire f-fr">
                            <input
                                class="btn"
                                type="button"
                                value="查询"
                                @click="getDemandArticleList"
                            >
                        </div>
                    </div>
                    <ul class="freelance-list">
                        <li
                            class="list"
                            v-for="(article,index) in articleList"
                            v-if="article.articleStatus!=0"
                            :key="index"
                        >
                            <div class="f-clearfix">
                                <p class="pic f-fl">
                                    <img :src="article.cover" width="197" height="111" alt>
                                </p>
                                <div class="txt f-fl">
                                    <!-- 不带原创标签[[ -->
                                    <h3 class="title">
                                        <span class="type">【{{ article.articleTypeText }}】</span>
                                        <a
                                            class="name f-hide-col-1 js-open-view"
                                            href="javascript:;"
                                            @click="previewArticle(article)"
                                        >{{ article.articleTitle }}</a>
                                    </h3>
                                    <!-- 不带原创标签]] -->
                                    <div class="intro">
                                        <!--王者荣耀-->
                                    </div>
                                    <p class="author">
                                        {{ article.userName }}
                                        <span class="time">{{ article.created}}</span>
                                    </p>
                                </div>
                                <div class="examine f-fl">
                                    <a
                                        class="switch js-down1"
                                        href="javascript:;"
                                        @click="article.showMediaDistribute = !article.showMediaDistribute"
                                    >
                                        发布渠道
                                        <i
                                            class="ico"
                                            :class="article.showMediaDistribute ? 'ico-down' : 'ico-up'"
                                        ></i>
                                    </a>
                                </div>
                                <!-- 待审核[[ -->
                                <div
                                    class="operation wait-accept f-fr"
                                    v-if="article.articleStatus == 10"
                                >
                                    <p class="status">
                                        <span class="color-theme">{{ article.articleStatusText }}</span>
                                    </p>
                                    <p class="btn">
                                        <a
                                            class="g-btn"
                                            href="javascript:;"
                                            @click="resolve(article.id)"
                                        >通过</a>
                                        <a
                                            class="g-btn js-open-reject"
                                            href="javascript:;"
                                            @click="reject(article.id)"
                                        >驳回</a>
                                    </p>
                                </div>
                                <!-- 待审核]] -->
                                <!-- 已通过[[ -->
                                <div class="operation check-passed f-fr" v-else>
                                    <!--<div class="operation reject-more f-fr">-->
                                    <p class="status">
                                        <span class="color-theme">{{ article.articleStatusText}}</span>
                                    </p>
                                </div>
                                <!-- 已通过]] -->
                            </div>
                            <ul
                                class="channel f-clearfix js-channel-show1"
                                style="display: block"
                                v-if="article.showMediaDistribute"
                            >
                                <li
                                    class="item f-fl"
                                    v-for="(media,index) in article.media"
                                    :key="index"
                                >
                                    <span class="head">
                                        <img :src="media.outCover" width="25" height="25">
                                    </span>
                                    <a
                                        class="name js-open-channel"
                                        href="javascript:;"
                                        style="width: 6rem"
                                        @click="showMediaDistributeDialog(media)"
                                        @mouseenter="media.showRemark = true"
                                        @mouseleave="media.showRemark = false"
                                    >{{ media.accountName }}</a>

                                    <span class="sync sync-success" v-if="media.status==1">
                                        同步
                                        <i class="ico ico-success"></i>
                                    </span>
                                    <span class="sync sync-failure" v-else-if="media.status==0">
                                        未同步
                                        <i class="ico ico-failure"></i>
                                    </span>
                                    <span class="sync sync-failure" v-else-if="media.status==3">
                                        同步失败
                                        <i class="ico ico-failure"></i>
                                    </span>
                                    <div
                                        class="sync-failure-reason"
                                        style="display: block"
                                        v-if="media.showRemark && media.remark"
                                    >
                                        <div class="sync-failure-triangle"></div>
                                        <div
                                            class="failure-reason-text f-hide-col-1"
                                        >{{media.remark}}</div>
                                    </div>
                                </li>
                            </ul>
                        </li>
                    </ul>

                    <!-- 空数据 start -->
                    <div class="empty" v-if="articleList.length==0">
                        <img class="empty-img" src="~Assets/img/pages/v4/radar-no-result.png">
                    </div>
                    <!-- 空数据 end -->
                </div>
                <div class="footer-bar">
                    <div class="footer-bar-btn">
                        <div class="g-bottom-btn btn-group">
                            <a class="button f-fr" href="javascript:;" @click="goBack">返回</a>
                            <!--选中状态  为a标签添加类 active -->
                            <!--<a class="button active f-fr" href="order_contribute.html">投稿</a>-->
                        </div>
                    </div>
                </div>
            </div>

            <!-- 分页[[ -->
            <pagination
                v-if="paginationConf.total >0"
                :total="paginationConf.total"
                :page-size="paginationConf.pageSize"
                @change="pageChange"
                ref="pager"
            ></pagination>
            <!-- 分页]] -->
            <!--内容预览 start-->
            <content-preview ref="contentPreview"></content-preview>
            <video-preview ref="videoPreview"></video-preview>
            <!--内容预览 end-->
            <media-distribute-info ref="mediaDistributeInfo"></media-distribute-info>
        </div>
    </div>
</template>
<style lang="scss" scoped>
@import "~Assets/sass/pages/v4/order/order_detail_supplier.scss";
@import "~Assets/vendor/swiper/swiper-3.2.7.min.css";
.order-detail-supplier .order-num-line .budget-all {
    position: relative;
}
.order-detail-supplier .order-num-line .answer-show {
    display: none;
    position: absolute;
    top: 27px;
    right: -124px;
}
.order-detail-supplier .order-num-line .answer-show .triangle {
    right: 50%;
    margin-right: -9px;
}
.order-detail-supplier .order-num-line .answer-show .answer-text {
    z-index: 100;
    width: 220px;
    padding: 12px 21px;
    background: #fff;
    font-size: 14px;
    color: #999999;
    box-shadow: 0 0 10px 0 rgba(214, 214, 214, 0.5);
}
.order-detail-supplier .order-num-line .order-num-detail {
    color: #666666;
}
.order-detail-supplier .order-num-line .ask-ico {
    z-index: 100;
    display: block;
    position: absolute;
    top: 0;
    right: -30px;
    width: 20px;
    height: 20px;
    background-image: url(~Assets/img/pages/v4/icon.png);
    background-position: -192px -124px;
}
.order-detail-supplier .order-num-line .ask-ico:hover .answer-show {
    display: block;
}
</style>
<script>
import selectBox from "Components/v4/dropdown/select_box";
import pagination from "Components/v4/pagination/pagination_v4";
import contentPreview from "Components/v4/pop/content_preview";
import videoPreview from "Components/v4/pop/video_preview";
import mediaDistributeInfo from "../supplier_order/media_distribute_info";
import {
    SupplierDemandInfo,
    SupplierDemandArticleList,
    ArticleDelete,
    SupplierOrderList,
    AssignSupplierOrderInfo,
    AssignSupplierOrder,
    DeleteSupplierOrder,
    SubmitSupplierOrder,
    SubmitStatement,
    SupplierOrderInfo,
    SupplierArticlePass,
    SupplierArticleReject
} from "Services/getData.js";
import {
    MAP_ARTICLE_TYPE_LIST,
    MAP_ARTICLE_STATUS_LIST
} from "Services/paramsConfig.js";
export default {
    name: "demand_detail_ugc.vue",
    data() {
        return {
            paginationConf: {
                total: 0,
                pageSize: 10
            },
            tabList: ["拆单列表", "内容审核"],
            curTab: 0,
            pageConf: {
                demandStatusList: [
                    {
                        id: 0,
                        name: "全部",
                        num: ""
                    },
                    {
                        id: 4003,
                        name: "执行中",
                        num: ""
                    },
                    {
                        id: 4004,
                        name: "已结单",
                        num: ""
                    }
                ],
                articleTypeList: [
                    {
                        name: "请选择",
                        id: ""
                    },
                    {
                        name: "图文",
                        id: 0
                    },
                    {
                        name: "视频",
                        id: 1
                    },
                    {
                        name: "小说",
                        id: 50
                    },
                    {
                        name: "漫画",
                        id: 60
                    }
                ],
                contentTypeList: [
                    {
                        id: 0,
                        name: "全部类型"
                    },
                    {
                        id: 1,
                        name: "PGC"
                    },
                    {
                        id: 2,
                        name: "PUGC"
                    },
                    {
                        id: 3,
                        name: "UGC"
                    }
                ],
                demandTypeList: [
                    {
                        name: "内容创作",
                        id: 10
                    },
                    {
                        name: "劳务服务",
                        id: 20
                    },
                    {
                        name: "福利奖金",
                        id: 30
                    },
                    {
                        name: "补贴补偿",
                        id: 40
                    }
                ],
                supplierOrderStatusList: [
                    {
                        id: 0,
                        name: "请选择订单状态"
                    },
                    {
                        id: 5000,
                        name: "制单中",
                        operation: [
                            "addAuthorOrder",
                            "edit",
                            "assign",
                            "delSupplierOrder"
                        ]
                    },
                    {
                        id: 5001,
                        name: "待接单",
                        operation: ["doSubmit"]
                    },
                    {
                        id: 5002,
                        name: "已驳回",
                        operation: ["addAuthorOrder", "edit", "assign"]
                    },
                    {
                        id: 5003,
                        name: "待审核",
                        operation: []
                    },
                    {
                        id: 5004,
                        name: "执行中",
                        operation: ["submitStatement"]
                    },
                    {
                        id: 5005,
                        name: "待结单",
                        operation: []
                    },
                    {
                        id: 5006,
                        name: "待结算",
                        operation: []
                    },
                    {
                        id: 5007,
                        name: "结算中",
                        operation: []
                    },
                    {
                        id: 5008,
                        name: "支付成功",
                        operation: []
                    },
                    {
                        id: 5009,
                        name: "支付失败",
                        operation: []
                    },
                    {
                        id: 5010,
                        name: "已结单",
                        operation: []
                    },
                    {
                        id: 2020,
                        name: "已中止",
                        operation: []
                    },
                    {
                        id: 5021,
                        name: "终止结算",
                        operation: []
                    }
                ],
                articleStatusList: [
                    {
                        name: "全部",
                        id: ""
                    },
                    {
                        name: "草稿中",
                        id: 0
                    },
                    {
                        name: "待审核",
                        id: 10
                    },
                    {
                        name: "外团已通过",
                        id: 15
                    },
                    {
                        name: "供应商已通过",
                        id: 18
                    },
                    {
                        name: "已通过",
                        id: 20
                    },
                    {
                        name: "已发布",
                        id: 30
                    },
                    {
                        name: "已驳回",
                        id: 50
                    },
                    {
                        name: "已定时",
                        id: 40
                    },
                    {
                        name: "已下线",
                        id: 60
                    },
                    {
                        name: "已删除",
                        id: 70
                    }
                ],
                articleStatusMap: {}
            },
            params: {
                demandId: "",
                orderStatus: "",
                orderName: "",
                pageSize: 10,
                pageIndex: 1, // 拆单列表用
                page: "" // 内容列表用的
            },
            supplierOrderList: [],
            articleList: [],
            demandInfo: {},
            assignOrderDialog: {
                show: false,
                supplierOrderId: "",
                authorList: []
            },
            tmp: {
                demandTypeList: {},
                orderStatusList: {},
                supplierOrderStatusList: {}
            },
            submitOrderDialog: {
                show: false,
                supplierOrderInfo: {}
            },
            mediaDistributeDialog: {
                show: false,
                outTitle: "",
                outCover: "",
                accountName: "",
                mediaName: ""
            }
        };
    },
    components: {
        selectBox,
        pagination,
        contentPreview,
        videoPreview,
        mediaDistributeInfo
    },
    created() {
        this.pageConf.articleStatusMap = this.objToStrMap(
            this.pageConf.articleStatusList
        );
        this.pageConf.supplierOrderStatusList.filter(type => {
            this.tmp.supplierOrderStatusList[type.id] = type.name;
        });
    },
    mounted() {
        let { demandId } = this.$route.query;
        if (demandId) {
            this.params.demandId = demandId;
            this.getSupplierOrderList();
            this.getDemandInfo();
        } else {
            this.$router.go(-1);
        }
    },
    methods: {
        async resolve(id) {
            this.$confirm("确认通过吗", "提示", {
                confirmButtonText: "确认",
                cancelButtonText: "取消"
            })
                .then(async () => {
                    let res = await SupplierArticlePass({
                        articleId: id
                    });
                    if (res.data.code == 0) {
                        this.getDemandArticleList();
                    }
                })
                .catch(() => {});
        },
        async reject(id) {
            this.$prompt("请输入驳回原因", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消"
            })
                .then(async ({ value }) => {
                    let res = await SupplierArticleReject({
                        articleId: id,
                        reason: value
                    });
                    if (res.data.code == 0) {
                        this.getDemandArticleList();
                    }
                })
                .catch(() => {});

            // this.$confirm('确认通过吗', '提示', { 'confirmButtonText': '确认', cancelButtonText: '取消' })
            //     .then(async () => {
            //         let res = await SupplierArticleReject({articleId: id});
            //         console.log(res.data.code == 0)
            //     }).catch(() => {});
        },
        pageChange(param) {
            this.params.pageSize = param.pageSize; // 发送给接口的字段
            this.params.pageIndex = param.pageIndex; // 发送给接口的字段
            this.params.page = param.pageIndex; // 发送给接口的字段
            if (this.curTab) {
                this.getDemandArticleList();
            } else {
                this.getSupplierOrderList();
            }
        },
        showMediaDistributeDialog(media) {
            this.$refs.mediaDistributeInfo.show(media);
        },
        changeTab(index) {
            this.curTab = index;
            this.params.pageIndex = 1; // 发送给接口的字段
            this.params.page = 1; // 发送给接口的字段
            if (this.curTab) {
                this.getDemandArticleList();
            } else {
                this.getSupplierOrderList();
            }
        },
        goBack() {
            this.$router.go(-1);
        },
        viewSupplierOrderDetail(supplierOrderInfo) {
            this.$router.history.push({
                name: "v4-order-supplier-detail-ugc",
                query: {
                    id: supplierOrderInfo.id
                }
            });
        },
        previewArticle(article) {
            if (article.articleType == 1) {
                this.$refs.videoPreview.remotePreview(article.id);
            } else {
                this.$refs.contentPreview.loadInfo(article.id);
            }
        },
        handleClick(order, action) {
            let tips = {
                deleteOrder: "删除",
                editOrder: "编辑",
                submitStatement: "提请结单",
                doSubmit: "提审",
                assignOrder: "派单"
            };
            let tip = tips[action] ? tips[action] : "";
            this.$confirm(`确认执行${tip}操作？`, "提示", {
                confirmButtonText: "确认",
                cancelButtonText: "取消"
            })
                .then(() => {
                    switch (action) {
                    case "deleteOrder":
                        this.deleteOrder(order);
                        break;
                    case "editOrder":
                        this.editOrder(order);
                        break;
                    case "submitStatement":
                        this.doSubmitStatement(order);
                        break;
                    case "doSubmit":
                        this.doSubmit(order);
                        break;
                    }
                })
                .catch(() => {});
        },
        editOrder(order) {
            this.$router.history.push({
                name: "v4-order-supplier-unpack",
                query: {
                    supplierOrderId: order.id
                }
            });
        },
        unpackOrder() {
            this.$router.history.push({
                name: "v4-order-supplier-unpack",
                query: {
                    demandId: this.demandInfo.id
                }
            });
        },
        showAssignDialog(order) {
            this.getAssignSupplierOrderInfo(order);
        },
        doAssignOrder() {
            this.assignOrder();
        },
        submitStatement(supplierOrderInfo) {
            this.getSupplierOrderInfo(supplierOrderInfo.id).then(() => {
                this.submitOrderDialog.show = true;
            });
        },
        async getSupplierOrderInfo(supplierOrderId) {
            let param = {
                orderId: supplierOrderId
            };
            let res = await SupplierOrderInfo(param);
            if (res.status === 200 && res.data.code == 0) {
                let data = res.data;
                if (data.code == 0) {
                    this.submitOrderDialog.supplierOrderInfo = data.data;
                }
            }
        },
        async deleteOrder(order) {
            let response = await DeleteSupplierOrder({
                orderId: order.id
            });
            let result = response.data;
            if (result.code === 0) {
                this.$alert("操作成功");
                this.getSupplierOrderList();
            }
        },
        async doSubmitStatement(orderId) {
            // 供应商提请结单
            let response = await SubmitStatement({
                orderId: orderId
            });
            let result = response.data;
            if (result.code === 0) {
                this.$alert("操作成功");
                this.submitOrderDialog.show = false;
                this.submitOrderDialog.supplierOrderInfo = {};
                this.getSupplierOrderList();
            }
        },
        async doSubmit(order) {
            let response = await SubmitSupplierOrder({
                orderId: order.id
            });
            let result = response.data;
            if (result.code === 0) {
                this.$alert("操作成功");
                this.getSupplierOrderList();
            }
        },
        async assignOrder() {
            let response = await AssignSupplierOrder({
                supplierOrderId: this.assignOrderDialog.supplierOrderId
            });
            let result = response.data;
            if (result.code === 0) {
                this.$alert("操作成功");
                this.getSupplierOrderList();
            }
            this.assignOrderDialog.show = false;
        },
        async getAssignSupplierOrderInfo(order) {
            this.loading = true;
            let response = await AssignSupplierOrderInfo({
                supplierOrderId: order.id
            });
            this.loading = false;
            let result = response.data;
            if (result.code === 0) {
                this.assignOrderDialog.authorList = result.data;
                this.assignOrderDialog.show = true;
                this.assignOrderDialog.supplierOrderId = order.id;
            }
        },

        async getSupplierOrderList() {
            let param = this.params;
            // param.demandId = 100298;
            let response = await SupplierOrderList(param);
            let result = response.data;
            if (result.code === 0) {
                this.supplierOrderList = result.data.data.map(order => {
                    order.orderStatusText = this.tmp.supplierOrderStatusList[
                        order.order_status
                    ];
                    return order;
                });
                this.paginationConf.total = result.data.count;
            }
        },
        async getDemandArticleList() {
            let response;
            let param = this.params;
            response = await SupplierDemandArticleList(param);
            let result = response.data;
            if (result.code !== 0) {
                // this.$alert(result.info);
            } else {
                this.articleList = result.data.data.map(article => {
                    article.showMediaDistribute = false;
                    article.articleStatusText = "";
                    article.articleTypeText = MAP_ARTICLE_TYPE_LIST.get(
                        article.articleType
                    );
                    if (
                        this.pageConf.articleStatusMap.has(
                            article.articleStatus
                        )
                    ) {
                        article.articleStatusText = this.pageConf.articleStatusMap.get(
                            article.articleStatus
                        );
                    }
                    article.operation = [];
                    return article;
                });
                this.paginationConf.total = result.data.total;
            }
        },
        async getDemandInfo() {
            let param = this.params;
            let res = await SupplierDemandInfo(param);
            if (res.status === 200 && res.data.code == 0) {
                let data = res.data;
                if (data.code == 0) {
                    let demandInfo = data.data;
                    let demandTypeList = {};
                    this.pageConf.demandTypeList.filter(type => {
                        demandTypeList[type.id] = type.name;
                    });
                    demandInfo.demandTypeText =
                        demandTypeList[demandInfo.demand_type];
                    this.demandInfo = demandInfo;
                }
            }
        },
        objToStrMap(obj) {
            let strMap = new Map();
            for (let v of Object.values(obj)) {
                strMap.set(v.id, v.name);
            }
            return strMap;
        },
        getRealAmountAddTax(order) {
            let real_tax = Number.isNaN(order.real_tax)
                ? 0
                : parseFloat(order.real_tax);
            let real_amount = Number.isNaN(order.real_amount)
                ? 0
                : parseFloat(order.real_amount);
            return this.$common.toThousandsFilter(real_tax + real_amount);
        },
        getBudgetAddTax(order) {
            let budget_amount = Number.isNaN(order.budget_amount)
                ? 0
                : parseFloat(order.budget_amount);
            let budget_tax = Number.isNaN(order.budget_tax)
                ? 0
                : parseFloat(order.budget_tax);
            return this.$common.toThousandsFilter(budget_amount + budget_tax);
        }
    }
};
</script>
